import { base } from './';
import {
  FeedbackCreateType,
  FeedbackUpdateType,
  SearchFeedbackQueryType,
} from 'types';

const PATH = '/feedback';

const get = (id: string) => base.get(`${PATH}/${id}`);

const getAll = (filter: SearchFeedbackQueryType) =>
  base.get(PATH, { params: { ...filter } });

const post = (data: FeedbackCreateType) => base.post(PATH, data);

const patch = ({ id, ...data }: FeedbackUpdateType) =>
  base.patch(`${PATH}/${id}`, data);

export { get, getAll, post, patch };
